import * as React from 'react';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import * as _ from 'lodash';

import { contactIdentifierSelector, contactIsOptedOutSelector } from '@/redux/app/selectors/contact';
import { optContactIn, optContactOut } from '@/redux/app/actions/contact';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';

export interface ContactOptInOutButtonProps {
  contactId: string;
}

export const ContactOptInOutButton = ({ contactId }: ContactOptInOutButtonProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const isOptedOut = useSelector(_.partial(contactIsOptedOutSelector, contactId));
  const identifier = useSelector(_.partial(contactIdentifierSelector, contactId));

  const dispatch = useDispatch();
  const handlePress = useCallback(() => {
    if (isOptedOut) {
      dispatch(optContactIn(subdomain, contactId));
    } else {
      const msg = `This will safely ensure '${identifier}' no longer receives any outbound messages, auto-responses, or broadcasts from your number. Continue?`;
      if (window.confirm(msg)) dispatch(optContactOut(subdomain, contactId));
    }
  }, [isOptedOut, contactId, subdomain]);

  return (
    <button
      type="button"
      className={classNames('space-right', 'ui-link', 'force-bg', isOptedOut ? ['formless_submitter', 'opt-in-contact'] : ['remover', 'opt-out-contact'])}
      id={`toggle-opt-in-${contactId}`}
      onKeyPress={handlePress}
      onClick={handlePress}
    >
      {isOptedOut ? 'Opt In' : 'Opt Out'}
    </button>
  );
};
